import styled from 'styled-components'

const StFieldContainer = styled.div<{ noMargin?: boolean }>`
  width: 100%;
  ${({ theme, noMargin }) => `
    margin-bottom: ${noMargin ? '0px' : theme.UI.SpacingPx.Space6};

    & > label {
      margin-bottom: ${theme.UI.SpacingPx.Space2};
    }
  `}
`

const StInputContainer = styled.label<{ disabled?: boolean; error?: boolean }>`
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  z-index: 1;

  transition: all 0.3s ease;

  ${({ theme, error }) => {
    return `
      background: url("data:image/svg+xml,<svg height='10px' width='10px' viewBox='0 0 16 16' fill='%23000000' xmlns='http://www.w3.org/2000/svg'><path d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/></svg>") no-repeat ${
        theme.Components.Input.Fill
      };
      background-position: calc(100% - 16px) center;
      border: 1px solid ${error ? theme.Components.Input.ErrorBorder : theme.Components.Input.Border};
      border-radius: ${theme.UI.BorderRadius.Small}px;
      color: ${theme.Components.Input.Text};

      &:focus-within {
        outline: none;
        border-color: ${theme.Components.Input.ActiveBorder};
        background-color: ${theme.Components.Input.ActiveFill};
      }

      & > select {
        width: 100%;
        padding: ${theme.UI.SpacingPx.Space4};
      }
    `
  }}

  ${({ theme, disabled }) => {
    return (
      disabled &&
      `
      background: none;
      border: 1px solid ${theme.Components.Input.DisabledBorder};
      background-color: ${theme.Components.Input.DisabledFill};
      color: ${theme.Components.Input.DisabledText};
    `
    )
  }}

    -moz-appearance: none !important;
  -webkit-appearance: none !important;
  appearance: none !important;
`

export { StFieldContainer, StInputContainer }
